export class ItemAreaCheck {
    public static isFirstColumn(number: number) {
        return number % 3 === 0;
    }

    public static isSecondColumn(number: number) {
        return number % 3 === 2;
    }

    public static isThirdColumn(number: number) {
        return number % 3 === 1;
    }

    public static isFirstDozen(number: number) {
        return number <= 12;
    }

    public static isSecondDozen(number: number) {
        return number > 12 && number <= 24;
    }

    public static isThirdDozen(number: number) {
        return number > 24;
    }
}
